import { FormGroup } from '@mui/material';
import { LinkAttributes, LinkI18nAttributes } from '@loyalty/editor-components';
import { htmlSanitize } from '@loyalty/shared-common';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputTextField } from '../../../../shared/forms/fields/InputTextField';
import { SelectField } from '../../../../shared/forms/fields/SelectField';
import { SwitchField } from '../../../../shared/forms/fields/SwitchField';
import { Trait } from '../utils/Trait';
import { TraitFormValue } from '../types';

type FormValue = TraitFormValue<LinkAttributes, LinkI18nAttributes>;

export function LinkWidgetTraits() {
  const { t } = useTranslation();

  const { control, watch } = useFormContext<FormValue>();

  const shouldTriggerEvent = watch('attributes.data-should-trigger-event');

  const content = watch('i18nAttributes.content');

  return (
    <FormGroup>
      <Trait>
        <InputTextField<FormValue>
          type="text"
          name="i18nAttributes.label"
          label={t('editor.link.label')}
          defaultValue={content ? htmlSanitize(content, { allowedTags: [] }).trim() : ''}
        />
      </Trait>
      <Trait>
        <InputTextField<FormValue>
          type="text"
          name="i18nAttributes.href"
          label="URL"
          placeholder={t('editor.link.url.placeholder')}
        />
      </Trait>
      <Trait>
        <SelectField<FormValue>
          control={control}
          name="attributes.target"
          label={t('editor.link.target')}
          defaultValue={'_self'}
          options={[
            { id: '_self', name: t('editor.link.target.this') },
            { id: '_blank', name: t('editor.link.target.new') },
          ]}
        />
      </Trait>
      <Trait>
        <SwitchField<FormValue>
          name="attributes.data-should-trigger-event"
          label={t('editor.link.trait.event')}
        />
      </Trait>
      {shouldTriggerEvent && (
        <Trait>
          <InputTextField<FormValue>
            type="text"
            name="attributes.data-button-id"
            label={t('editor.link.trait.id')}
          />
        </Trait>
      )}
    </FormGroup>
  );
}
